import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  url: 'https://cdn.magicpatterns.com/uploads/6cezJSFMcKR9mTsGBgdVJz/F8254A9E-695A-404D-BEEA-5682BB8C61F2.png',
  alt: 'Custom pergola and manicured lawn',
  className: 'md:col-span-2 md:row-span-2'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/6SLqco5ce5T9Zziw6a3Pmu/panchos2.png',
  alt: 'Fresh mulch and landscaped garden beds',
  className: 'md:col-span-1 md:row-span-1'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/fuNhmabxTdJRrfS1p6A8VM/67293209-E096-41FB-9832-3F731D4D475B.png',
  alt: 'Decorative potted plants on stone patio',
  className: 'md:col-span-1 md:row-span-1'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/5EtN2pXJAaQwhHJnktUFwV/panchos1.png',
  alt: 'Professional brick paving installation by the lake',
  className: 'md:col-span-1 md:row-span-1'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/tTH36sAEZPR6uZDYgB3dxt/panchos3.png',
  alt: 'Expert stone patio construction in progress',
  className: 'md:col-span-2 md:row-span-1'
}];
export function GallerySection() {
  return <section id="gallery" className="py-24 bg-white" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-77">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-sm font-bold tracking-widest text-forest-500 uppercase mb-3" data-id="element-78">
            Our Work
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-heading font-bold text-earth-900 mb-6" data-id="element-79">
            Recent Projects
          </motion.h3>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-earth-700/80" data-id="element-80">
            Take a look at some of our recent landscaping and hardscaping
            transformations across Illinois and Wisconsin.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 auto-rows-[250px] md:auto-rows-[300px]" data-id="element-81">
          {images.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`rounded-2xl overflow-hidden relative group bg-earth-100 ${image.className}`} data-id="element-82">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-83" />
              <div className="absolute inset-0 bg-gradient-to-t from-earth-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-84">
                <p className="text-white font-medium translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-85">
                  {image.alt}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}